import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { isTestEnv } from "@faire/web--source/common/user-agent/isTestEnv";
import { getGlobalLookup } from "./lookup";
import { getAllOverriddenGlobalProperties } from "./override";
export function getGlobalProperty(name, defaultValue) {
    var allOverriddenPageData = getAllOverriddenGlobalProperties();
    // Check if direct reference is mocked out
    if (name in allOverriddenPageData) {
        var overrideValue = allOverriddenPageData[name];
        if (!isTestEnv()) {
            // eslint-disable-next-line no-console
            console.log("Using global property override for ".concat(name, " of ").concat(JSON.stringify(overrideValue)));
        }
        return overrideValue !== null && overrideValue !== void 0 ? overrideValue : defaultValue;
    }
    var overrideProperties = {};
    var allOverriddenPageDataKeys = Object.keys(allOverriddenPageData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allOverriddenPageDataKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var _key_split = _sliced_to_array(key.split("."), 2), parent = _key_split[0], child = _key_split[1];
            // Check if child reference is mocked out
            if (name === parent && child !== undefined) {
                var overrideValue1 = allOverriddenPageData[key];
                if (!isTestEnv()) {
                    // eslint-disable-next-line no-console
                    console.log("Using global property override for ".concat(key, " of ").concat(JSON.stringify(overrideValue1)));
                }
                overrideProperties[child] = overrideValue1;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _getGlobalLookup;
    var value = (_getGlobalLookup = getGlobalLookup()(name)) !== null && _getGlobalLookup !== void 0 ? _getGlobalLookup : defaultValue;
    if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_DEBUG_GLOBAL_LOOKUP && !globalsToSkip.includes(name)) {
        var _stack;
        // eslint-disable-next-line no-console
        console.log("Global Lookup: ".concat(name), (_stack = new Error().stack) === null || _stack === void 0 ? void 0 : _stack.split("\n").slice(1, 6));
    }
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && Object.keys(overrideProperties).length !== 0) {
        return _object_spread({}, value, overrideProperties);
    }
    return value;
}
// Globals that we don't want to log - they are either expected (like window)
// or are too noisy to give any insight.
var globalsToSkip = [
    "window",
    "document",
    "location",
    "navigator",
    "needsHydration",
    "envName",
    "faire.app",
    "isRobot",
    "isPrerender",
    "settingsValues",
    "user",
    "retailer"
];
